import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "font-weight-bold flex-fill" }
const _hoisted_3 = { class: "text-muted text-right" }
const _hoisted_4 = { class: "ml-2 pr-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { style: {"line-height":"2.5em"} }
const _hoisted_10 = { class: "text-nowrap" }
const _hoisted_11 = {
  style: {"line-height":"2.5em"},
  class: "ml-3"
}
const _hoisted_12 = { class: "text-nowrap" }

import {__} from "~/ts/library/Translate";
import DateHelper from "~/ts/library/Date";
import {computed} from "vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import DialogDataCardSections from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/DialogDataCardSections.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import DialogOperatorsList from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dialogsTab/DialogOperatorsList.vue";
import {goToDialog} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dialogsTab/goToDialog";
import {copyToClipboardWithNotification} from "~/ts/library/CopyToClipboard";

import OperatorApplicationDialogOpenApiModel = OperatorApplicationApi.OperatorApplicationDialogOpenApiModel;
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import OperatorGetParamsSiteOpenApiModel = OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel;
import OperatorGetParamsSiteAiAssistantActionsOpenApiModel = OperatorApplicationApi.OperatorGetParamsSiteAiAssistantActionsOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DialogCard"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dialog: {},
    userdata: {},
    isAiAvailableByLicense: { type: Boolean },
    site: {}
  },
  setup(__props: any) {

let props = __props;

const GO_TO_DIALOG = "goToDialog";
const COPY_LINK_TO_DIALOG = "copyLinkToDialog";
const AI_ASSISTANT = "aiAssistant";

let showAiSection = computed(() => {
    if (props.isAiAvailableByLicense) {
        let actions = props.site.ai.actions;
        for (let key in actions) {
            if (actions.hasOwnProperty(key)) {
                if (actions[key as keyof OperatorGetParamsSiteAiAssistantActionsOpenApiModel] === true) {
                    return true;
                }
            }
        }
    }
    return false;
})




async function runAiAssistant() {
    let p: OperatorApplicationApi.OperatorRunAiAssistantOnDialogOpenApiModel = {
        username: props.userdata.username,
        dialogId: props.dialog.id
    };
    let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorRunAiAssistantOnDialogResultOpenApiModel>({
        url: `/message/runAiAssistantOnDialog`,
        p
    })).send();
    if (result.isSuccess) {
        OpenApiResult.showMessage(__("Задача поставлена, скоро AI-ассистент проведёт анализ диалога"), "success");
    } else {
        result.showMessageOnError();
    }
}

function onDropdownMenuCommand(command: string) {
    if (command == GO_TO_DIALOG) {
        goToDialog(props.userdata.username, props.dialog.id);
    } else if (command == AI_ASSISTANT) {
        runAiAssistant();
    } else if (command == COPY_LINK_TO_DIALOG) {
        copyToClipboardWithNotification(props.dialog.linkToApplication);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createVNode(ElCardSection, { class: "pt-2 pb-2 pr-0 sticky -top" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)('Диалог')) + " №" + _toDisplayString(__props.dialog.id), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString((new (_unref(DateHelper))(__props.dialog.dtOpen)).toLocaleDateString()), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_dropdown, {
                trigger: "click",
                onCommand: onDropdownMenuCommand
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { command: GO_TO_DIALOG }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, {
                            icon: "share-from-square",
                            class: "mr-2"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(__)('Перейти к диалогу')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, { command: COPY_LINK_TO_DIALOG }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, {
                            icon: "copy",
                            class: "mr-2"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(__)('Скопировать ссылку на диалог')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, { command: AI_ASSISTANT }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, {
                            icon: "head-side-brain",
                            class: "mr-2"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(__)('Подвести итоги AI-ассистентом')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { link: "" }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: "ellipsis-v" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      (_unref(showAiSection))
        ? (_openBlock(), _createBlock(ElCardSection, { key: 0 }, {
            default: _withCtx(() => [
              (!__props.dialog.ai.isDone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (__props.dialog.ai.isTaskOnCloseCreated)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(__)("AI-итоги диалога готовятся")), 1)
                        ], 64))
                      : (!__props.dialog.dtClose)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(__)("AI-итоги будут подведены после завершения диалога")), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_unref(__)("AI-итоги по этому диалогу подводиться не будут")), 1)
                          ], 64))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.site.ai.actions.satisfy || __props.site.ai.actions.emotions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (__props.site.ai.actions.satisfy)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (__props.dialog.ai.isClientSatisfied)
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 0,
                                      type: "success",
                                      class: "mb-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(__)("Доволен")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 1,
                                      type: "danger",
                                      class: "mb-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(__)("Недоволен")), 1)
                                      ]),
                                      _: 1
                                    }))
                              ], 64))
                            : _createCommentVNode("", true),
                          (__props.site.ai.actions.emotions)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (__props.dialog.ai.emotion)
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 0,
                                      style: _normalizeStyle({
                                background: __props.dialog.ai.emotion.color,
                                color: __props.dialog.ai.emotion.additionalColor
                            }),
                                      class: "mb-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(FontAwesomeIcon, {
                                          icon: __props.dialog.ai.emotion.icon
                                        }, null, 8, ["icon"]),
                                        _createTextVNode(" " + _toDisplayString(_unref(__)("Эмоции")) + ": " + _toDisplayString(__props.dialog.ai.emotion.descr), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.site.ai.actions.summarize)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.dialog.ai.conversationSummarize), 1))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(DialogDataCardSections, {
        dialog: __props.dialog,
        userdata: __props.userdata,
        site: __props.site
      }, null, 8, ["dialog", "userdata", "site"]),
      _createVNode(ElCardSection, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(DialogOperatorsList, {
              class: "flex-fill",
              max: 5,
              dialog: __props.dialog
            }, null, 8, ["dialog"]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createVNode(FontAwesomeIcon, {
                  icon: "comments",
                  class: "mr-1"
                }),
                _createTextVNode(" " + _toDisplayString(__props.dialog.clientRealMessageCount + __props.dialog.operatorRealMessageCount), 1)
              ])), [
                [_directive_my_tooltip, {text: _unref(__)('Количество реальных сообщений между клиентом и оператором'), delay: 1000}]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createVNode(FontAwesomeIcon, { icon: "clock" }),
                _createTextVNode(" " + _toDisplayString(_unref(DateHelper).secondsFormatToClosestFloor(_unref(props).dialog.duration ?? (_unref(DateHelper).nowEverySecondInSeconds - _unref(props).dialog.dtOpen))), 1)
              ])), [
                [_directive_my_tooltip, {text: _unref(__)('Продолжительность диалога'), delay: 1000}]
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})